module.exports = __webpack_public_path__ + "static/img/twjd-sdo20.7d4fe53.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo20.png
// module id = 862
// module chunks = 0